<template>
  <div class="student-map-kpi-strip policy-kpi-strip" aria-label="实训指标和财政使用情况">
    <article v-for="item in items" :key="item.key" class="student-map-kpi-card" :data-kpi="item.key" :title="item.description || item.name">
      <span class="student-map-kpi-icon" :style="{ background: item.color }">{{ item.icon }}</span>
      <span class="student-map-kpi-name">{{ item.name }}</span>
      <span class="student-map-kpi-value">{{ display(item.value) }} <small v-if="hasTarget(item.target)">/ {{ display(item.target) }} {{ item.unit || '' }}</small><small v-else>{{ item.unit || '' }}</small></span>
      <policy-progress-bar :value="item.value" :target="item.target" :label="item.name" :color="item.color" :budget="item.key === 'budget-usage'" />
    </article>
  </div>
</template>

<script>
import PolicyProgressBar from './PolicyProgressBar.vue'
import { policyDisplayNumber, policyNumber } from '../services/policyProgress'

export default {
  name: 'PolicyKpiStrip', components: { PolicyProgressBar },
  props: { items: { type: Array, default: () => [] } },
  methods: { display: policyDisplayNumber, hasTarget (value) { return policyNumber(value) != null } }
}
</script>
